var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkout-form" }, [
    _c(
      "div",
      {
        staticClass:
          "checkout-form__wrapper insicht insicht--fade-in insicht--fast"
      },
      [
        _c(
          "div",
          { staticClass: "checkout-form__container" },
          [
            !_vm.isLoggedIn
              ? _c("ShopHeader", {
                  staticClass: "checkout-form__header",
                  attrs: {
                    title: "",
                    "sub-title": "",
                    "login-text": this.$t(
                      "shoplist.shopHeader.loginTextCheckout"
                    ),
                    disabled: _vm.formLocked
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("h1", {
              staticClass: "checkout-form__headline",
              domProps: { innerHTML: _vm._s(_vm.$t("checkout.title")) }
            }),
            _vm._v(" "),
            !_vm.cartIsDetached
              ? _c("Button", {
                  staticClass:
                    "checkout-form__back-to-shop checkout-form__back-to-shop--top",
                  attrs: {
                    level: "tertiary",
                    type: "button",
                    text: _vm.$t("checkout.continueShopping"),
                    arrow: "",
                    reverse: "",
                    disabled: _vm.formLocked
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.backToShop.apply(null, arguments)
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.notifyMessages, function(message, i) {
              return _c("GeneralMessage", {
                key: "message" + i + message.message,
                ref: "notificationMessages",
                refInFor: true,
                attrs: { message: message.message, type: message.type }
              })
            }),
            _vm._v(" "),
            _vm._l(_vm.checkoutMessagesNormal, function(message, i) {
              return _c("GeneralMessage", {
                key: "checkoutmessage" + i + message.message,
                ref: "checkoutMessages",
                refInFor: true,
                attrs: { message: message.message, type: message.type }
              })
            }),
            _vm._v(" "),
            _vm.cartOrderTimePassed
              ? _c("GeneralMessage", {
                  ref: "notificationMessages",
                  attrs: {
                    message: _vm.$t("checkout.errorTimePassed"),
                    type: "error"
                  },
                  on: { click: _vm.onTimeEdit }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("CheckoutCartButton", {
              attrs: { "show-tip": "", "show-co2": "" }
            }),
            _vm._v(" "),
            _c("ValidationObserver", {
              ref: "form",
              staticClass: "checkout-form__form-wrapper",
              attrs: { tag: "form", novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var invalid = ref.invalid
                    var errors = ref.errors
                    return [
                      _vm.showEmail || !_vm.shippingAddressDisabled
                        ? _c(
                            "div",
                            { staticClass: "checkout-form__block" },
                            [
                              _c("h2", {
                                staticClass: "checkout-form__block-title",
                                domProps: {
                                  innerHTML: _vm._s(_vm.addressTitle)
                                }
                              }),
                              _vm._v(" "),
                              _vm.isOutdoorDelivery
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "checkout-form__outdoor-delivery"
                                      },
                                      [
                                        _vm.cartOutdoorDeliveryPoint.image &&
                                        _vm.cartOutdoorDeliveryPoint.image.path
                                          ? _c(
                                              "figure",
                                              {
                                                staticClass:
                                                  "checkout-form__outdoor-delivery-image"
                                              },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "checkout-form__outdoor-delivery-image-element",
                                                  attrs: {
                                                    src:
                                                      _vm
                                                        .cartOutdoorDeliveryPoint
                                                        .image.path,
                                                    alt:
                                                      "outdoor delivery point image"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("address", {
                                          directives: [
                                            {
                                              name: "sanitize",
                                              rawName: "v-sanitize",
                                              value: _vm.outdoorDeliveryAddress,
                                              expression:
                                                "outdoorDeliveryAddress"
                                            }
                                          ],
                                          staticClass:
                                            "checkout-form__outdoor-delivery-address"
                                        }),
                                        _vm._v(" "),
                                        _c("Button", {
                                          staticClass:
                                            "checkout-form__outdoor-delivery-link",
                                          attrs: {
                                            type: "button",
                                            href:
                                              "http://www.google.com/maps/place/" +
                                              _vm.cartOutdoorDeliveryPoint
                                                .latitude +
                                              "," +
                                              _vm.cartOutdoorDeliveryPoint
                                                .longitude,
                                            target: "_blank",
                                            level: "tertiary",
                                            arrow: "",
                                            text: _vm.$t(
                                              "checkout.outdoorDelivery.googleMapsLink"
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("h3", {
                                      staticClass:
                                        "checkout-form__block-subtitle",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("checkout.personalData")
                                        )
                                      }
                                    })
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showEmail
                                ? _c(
                                    "div",
                                    { staticClass: "input-row" },
                                    [
                                      _c("ValidationProvider", {
                                        staticClass: "input-row__wrapper",
                                        attrs: {
                                          name: "email",
                                          rules: _vm.shippingAddressLocked
                                            ? ""
                                            : "required|email",
                                          tag: "div",
                                          customMessages: {
                                            required: _vm.$t(
                                              "forms.errors.fieldEmpty"
                                            ),
                                            email: _vm.$t(
                                              "forms.errors.emailInvalid"
                                            )
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(ref) {
                                                var errors = ref.errors
                                                var invalid = ref.invalid
                                                var validated = ref.validated
                                                return [
                                                  _c("FormInput", {
                                                    attrs: {
                                                      type: "email",
                                                      name: "email",
                                                      autocomplete: "email",
                                                      placeholder: _vm.$t(
                                                        "forms.labels.email"
                                                      ),
                                                      label: _vm.$t(
                                                        "forms.labels.email"
                                                      ),
                                                      error: errors.length > 0,
                                                      readonly: !!_vm.isLoggedIn,
                                                      disabled:
                                                        _vm.formLocked ||
                                                        _vm.shippingAddressLocked,
                                                      required: !_vm.shippingAddressLocked
                                                    },
                                                    model: {
                                                      value: _vm.form.email,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "email",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.email"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  invalid && validated
                                                    ? _c("span", {
                                                        staticClass:
                                                          "input-error",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            errors[0]
                                                          )
                                                        }
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass:
                                                      "additional-info",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$t(
                                                          "checkout.emailHint"
                                                        )
                                                      )
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.shippingAddressDisabled
                                ? _c("ValidationObserver", {
                                    ref: "shippingAddress",
                                    attrs: {
                                      tag: "section",
                                      vid: "shippingAddress"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "input-row" },
                                                [
                                                  _c("ValidationProvider", {
                                                    staticClass:
                                                      "input-row__wrapper",
                                                    attrs: {
                                                      name: "shippingFirstname",
                                                      rules: _vm.shippingAddressLocked
                                                        ? ""
                                                        : "required",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            var validated =
                                                              ref.validated
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "text",
                                                                  placeholder: _vm.$t(
                                                                    "forms.labels.firstname"
                                                                  ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.firstname"
                                                                  ),
                                                                  name:
                                                                    "firstname",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  disabled:
                                                                    _vm.formLocked ||
                                                                    _vm.shippingAddressLocked,
                                                                  required: !_vm.shippingAddressLocked
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.form
                                                                      .shippingAddress
                                                                      .firstName,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.form
                                                                        .shippingAddress,
                                                                      "firstName",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "form.shippingAddress.firstName"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              invalid &&
                                                              validated
                                                                ? _c("span", {
                                                                    staticClass:
                                                                      "input-error",
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    }
                                                                  })
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    staticClass:
                                                      "input-row__wrapper",
                                                    attrs: {
                                                      name: "shippingLastname",
                                                      rules: _vm.shippingAddressLocked
                                                        ? ""
                                                        : "required",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            var validated =
                                                              ref.validated
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "text",
                                                                  placeholder: _vm.$t(
                                                                    "forms.labels.lastname"
                                                                  ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.lastname"
                                                                  ),
                                                                  name:
                                                                    "lastname",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  disabled:
                                                                    _vm.formLocked ||
                                                                    _vm.shippingAddressLocked,
                                                                  required: !_vm.shippingAddressLocked
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.form
                                                                      .shippingAddress
                                                                      .lastName,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.form
                                                                        .shippingAddress,
                                                                      "lastName",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "form.shippingAddress.lastName"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              invalid &&
                                                              validated
                                                                ? _c("span", {
                                                                    staticClass:
                                                                      "input-error",
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    }
                                                                  })
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _vm.showAddress
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "input-row"
                                                    },
                                                    [
                                                      _c("FormInput", {
                                                        attrs: {
                                                          type: "text",
                                                          placeholder: _vm.$t(
                                                            "forms.labels.company"
                                                          ),
                                                          label: _vm.$t(
                                                            "forms.labels.company"
                                                          ),
                                                          labelOption: _vm.$t(
                                                            "forms.labels.optional"
                                                          ),
                                                          name: "company",
                                                          disabled:
                                                            _vm.formLocked ||
                                                            _vm.shippingAddressLocked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form
                                                              .shippingAddress
                                                              .company,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form
                                                                .shippingAddress,
                                                              "company",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.shippingAddress.company"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showAddress
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "input-row"
                                                    },
                                                    [
                                                      _c("ValidationObserver", {
                                                        ref: "shippingStreetNr",
                                                        staticClass:
                                                          "input-row__wrapper",
                                                        attrs: { tag: "div" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var validated =
                                                                  ref.validated
                                                                var invalid =
                                                                  ref.invalid
                                                                var errors =
                                                                  ref.errors
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "input-group"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "ValidationProvider",
                                                                        {
                                                                          staticClass:
                                                                            "input-group__span-9",
                                                                          attrs: {
                                                                            name:
                                                                              "shippingStreet",
                                                                            rules: _vm.addressRequired
                                                                              ? "required"
                                                                              : "",
                                                                            tag:
                                                                              "div",
                                                                            customMessages: {
                                                                              required: _vm.$t(
                                                                                "forms.errors.fieldEmpty"
                                                                              )
                                                                            }
                                                                          },
                                                                          scopedSlots: _vm._u(
                                                                            [
                                                                              {
                                                                                key:
                                                                                  "default",
                                                                                fn: function(
                                                                                  ref
                                                                                ) {
                                                                                  var errors =
                                                                                    ref.errors
                                                                                  var invalid =
                                                                                    ref.invalid
                                                                                  return [
                                                                                    _c(
                                                                                      "FormInput",
                                                                                      {
                                                                                        attrs: {
                                                                                          type:
                                                                                            "text",
                                                                                          placeholder: _vm.$t(
                                                                                            "forms.labels.street"
                                                                                          ),
                                                                                          label: _vm.$t(
                                                                                            "forms.labels.street"
                                                                                          ),
                                                                                          labelOption: _vm.addressRequired
                                                                                            ? ""
                                                                                            : _vm.$t(
                                                                                                "forms.labels.optional"
                                                                                              ),
                                                                                          name:
                                                                                            "street",
                                                                                          error:
                                                                                            errors.length >
                                                                                            0,
                                                                                          required:
                                                                                            _vm.addressRequired,
                                                                                          disabled:
                                                                                            _vm.formLocked ||
                                                                                            _vm.shippingAddressLocked
                                                                                        },
                                                                                        model: {
                                                                                          value:
                                                                                            _vm
                                                                                              .form
                                                                                              .shippingAddress
                                                                                              .street,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm
                                                                                                .form
                                                                                                .shippingAddress,
                                                                                              "street",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "form.shippingAddress.street"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                }
                                                                              }
                                                                            ],
                                                                            null,
                                                                            true
                                                                          )
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "ValidationProvider",
                                                                        {
                                                                          staticClass:
                                                                            "input-group__span-3",
                                                                          attrs: {
                                                                            name:
                                                                              "shippingStreetNumber",
                                                                            rules: _vm.addressRequired
                                                                              ? "required"
                                                                              : "",
                                                                            tag:
                                                                              "div",
                                                                            customMessages: {
                                                                              required: _vm.$t(
                                                                                "forms.errors.fieldEmpty"
                                                                              )
                                                                            }
                                                                          },
                                                                          scopedSlots: _vm._u(
                                                                            [
                                                                              {
                                                                                key:
                                                                                  "default",
                                                                                fn: function(
                                                                                  ref
                                                                                ) {
                                                                                  var errors =
                                                                                    ref.errors
                                                                                  var invalid =
                                                                                    ref.invalid
                                                                                  return [
                                                                                    _c(
                                                                                      "FormInput",
                                                                                      {
                                                                                        attrs: {
                                                                                          type:
                                                                                            "text",
                                                                                          placeholder: _vm.$t(
                                                                                            "forms.labels.number"
                                                                                          ),
                                                                                          label: _vm.$t(
                                                                                            "forms.labels.number"
                                                                                          ),
                                                                                          labelOption: _vm.addressRequired
                                                                                            ? ""
                                                                                            : _vm.$t(
                                                                                                "forms.labels.optional"
                                                                                              ),
                                                                                          name:
                                                                                            "number",
                                                                                          error:
                                                                                            errors.length >
                                                                                            0,
                                                                                          required:
                                                                                            _vm.addressRequired,
                                                                                          disabled:
                                                                                            _vm.formLocked ||
                                                                                            _vm.shippingAddressLocked
                                                                                        },
                                                                                        model: {
                                                                                          value:
                                                                                            _vm
                                                                                              .form
                                                                                              .shippingAddress
                                                                                              .streetNumber,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm
                                                                                                .form
                                                                                                .shippingAddress,
                                                                                              "streetNumber",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "form.shippingAddress.streetNumber"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                }
                                                                              }
                                                                            ],
                                                                            null,
                                                                            true
                                                                          )
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  invalid &&
                                                                  validated
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "input-error input-group__span-12",
                                                                          domProps: {
                                                                            innerHTML: _vm._s(
                                                                              Object.values(
                                                                                errors
                                                                              )
                                                                                .filter(
                                                                                  function(
                                                                                    value
                                                                                  ) {
                                                                                    return !!value
                                                                                      .join(
                                                                                        ""
                                                                                      )
                                                                                      .trim()
                                                                                  }
                                                                                )
                                                                                .join(
                                                                                  " "
                                                                                )
                                                                            )
                                                                          }
                                                                        }
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      }),
                                                      _vm._v(" "),
                                                      _c("ValidationObserver", {
                                                        ref: "shippingZipCity",
                                                        staticClass:
                                                          "input-row__wrapper",
                                                        attrs: { tag: "div" },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function(
                                                                ref
                                                              ) {
                                                                var dirty =
                                                                  ref.dirty
                                                                var validated =
                                                                  ref.validated
                                                                var invalid =
                                                                  ref.invalid
                                                                var errors =
                                                                  ref.errors
                                                                return [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "input-group"
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "ValidationProvider",
                                                                        {
                                                                          staticClass:
                                                                            "input-group__span-4 input-group__span-xxl-3",
                                                                          attrs: {
                                                                            name:
                                                                              "shippingZip",
                                                                            rules: _vm.addressRequired
                                                                              ? "required|digits:4"
                                                                              : _vm.shippingAddressLocked
                                                                              ? ""
                                                                              : "digits:4",
                                                                            tag:
                                                                              "div",
                                                                            customMessages: {
                                                                              required: _vm.$t(
                                                                                "forms.errors.fieldEmpty"
                                                                              ),
                                                                              digits: _vm.$t(
                                                                                "forms.errors.zip"
                                                                              )
                                                                            }
                                                                          },
                                                                          scopedSlots: _vm._u(
                                                                            [
                                                                              {
                                                                                key:
                                                                                  "default",
                                                                                fn: function(
                                                                                  ref
                                                                                ) {
                                                                                  var errors =
                                                                                    ref.errors
                                                                                  var invalid =
                                                                                    ref.invalid
                                                                                  return [
                                                                                    _c(
                                                                                      "FormInput",
                                                                                      {
                                                                                        ref:
                                                                                          "shippingZipInput",
                                                                                        attrs: {
                                                                                          type:
                                                                                            "text",
                                                                                          placeholder: _vm.$t(
                                                                                            "forms.labels.zip"
                                                                                          ),
                                                                                          label: _vm.$t(
                                                                                            "forms.labels.zip"
                                                                                          ),
                                                                                          labelOption: _vm.addressRequired
                                                                                            ? ""
                                                                                            : _vm.$t(
                                                                                                "forms.labels.optional"
                                                                                              ),
                                                                                          name:
                                                                                            "zip",
                                                                                          minlength: 4,
                                                                                          maxlength: 4,
                                                                                          inputmode:
                                                                                            "decimal",
                                                                                          pattern:
                                                                                            "[0-9]{4}",
                                                                                          error:
                                                                                            errors.length >
                                                                                            0,
                                                                                          required:
                                                                                            _vm.addressRequired,
                                                                                          readonly:
                                                                                            _vm.zipLocked,
                                                                                          disabled:
                                                                                            _vm.formLocked ||
                                                                                            _vm.shippingAddressLocked
                                                                                        },
                                                                                        on: {
                                                                                          keydown:
                                                                                            _vm.onZipKeydown,
                                                                                          input:
                                                                                            _vm.onZipInput
                                                                                        },
                                                                                        model: {
                                                                                          value:
                                                                                            _vm
                                                                                              .form
                                                                                              .shippingAddress
                                                                                              .postcode,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm
                                                                                                .form
                                                                                                .shippingAddress,
                                                                                              "postcode",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "form.shippingAddress.postcode"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                }
                                                                              }
                                                                            ],
                                                                            null,
                                                                            true
                                                                          )
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "ValidationProvider",
                                                                        {
                                                                          staticClass:
                                                                            "input-group__span-8 input-group__span-xxl-9",
                                                                          attrs: {
                                                                            name:
                                                                              "shippingCity",
                                                                            rules: _vm.addressRequired
                                                                              ? "required"
                                                                              : "",
                                                                            tag:
                                                                              "div",
                                                                            customMessages: {
                                                                              required: _vm.$t(
                                                                                "forms.errors.fieldEmpty"
                                                                              )
                                                                            }
                                                                          },
                                                                          scopedSlots: _vm._u(
                                                                            [
                                                                              {
                                                                                key:
                                                                                  "default",
                                                                                fn: function(
                                                                                  ref
                                                                                ) {
                                                                                  var errors =
                                                                                    ref.errors
                                                                                  var invalid =
                                                                                    ref.invalid
                                                                                  return [
                                                                                    _c(
                                                                                      "FormInput",
                                                                                      {
                                                                                        attrs: {
                                                                                          type:
                                                                                            "text",
                                                                                          placeholder: _vm.$t(
                                                                                            "forms.labels.city"
                                                                                          ),
                                                                                          label: _vm.$t(
                                                                                            "forms.labels.city"
                                                                                          ),
                                                                                          labelOption: _vm.addressRequired
                                                                                            ? ""
                                                                                            : _vm.$t(
                                                                                                "forms.labels.optional"
                                                                                              ),
                                                                                          name:
                                                                                            "city",
                                                                                          error:
                                                                                            errors.length >
                                                                                            0,
                                                                                          required:
                                                                                            _vm.addressRequired,
                                                                                          disabled:
                                                                                            _vm.formLocked ||
                                                                                            _vm.shippingAddressLocked
                                                                                        },
                                                                                        model: {
                                                                                          value:
                                                                                            _vm
                                                                                              .form
                                                                                              .shippingAddress
                                                                                              .city,
                                                                                          callback: function(
                                                                                            $$v
                                                                                          ) {
                                                                                            _vm.$set(
                                                                                              _vm
                                                                                                .form
                                                                                                .shippingAddress,
                                                                                              "city",
                                                                                              $$v
                                                                                            )
                                                                                          },
                                                                                          expression:
                                                                                            "form.shippingAddress.city"
                                                                                        }
                                                                                      }
                                                                                    )
                                                                                  ]
                                                                                }
                                                                              }
                                                                            ],
                                                                            null,
                                                                            true
                                                                          )
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _vm._v(" "),
                                                                  invalid &&
                                                                  (validated ||
                                                                    dirty)
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "input-error input-group__span-12",
                                                                          domProps: {
                                                                            innerHTML: _vm._s(
                                                                              Object.values(
                                                                                errors
                                                                              )
                                                                                .filter(
                                                                                  function(
                                                                                    value
                                                                                  ) {
                                                                                    return !!value
                                                                                      .join(
                                                                                        ""
                                                                                      )
                                                                                      .trim()
                                                                                  }
                                                                                )
                                                                                .join(
                                                                                  " "
                                                                                )
                                                                            )
                                                                          }
                                                                        }
                                                                      )
                                                                    : _vm._e()
                                                                ]
                                                              }
                                                            }
                                                          ],
                                                          null,
                                                          true
                                                        )
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showAddress
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "input-row"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-row__wrapper"
                                                        },
                                                        [
                                                          _c("FormInput", {
                                                            attrs: {
                                                              type: "text",
                                                              placeholder: _vm.$t(
                                                                "forms.labels.addressDetails"
                                                              ),
                                                              label: _vm.$t(
                                                                "forms.labels.addressDetails"
                                                              ),
                                                              labelOption: _vm.$t(
                                                                "forms.labels.optional"
                                                              ),
                                                              name:
                                                                "addressdetails",
                                                              disabled:
                                                                _vm.formLocked ||
                                                                _vm.shippingAddressLocked
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.form
                                                                  .shippingAddress
                                                                  .details,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.form
                                                                    .shippingAddress,
                                                                  "details",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "form.shippingAddress.details"
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("span", {
                                                            staticClass:
                                                              "additional-info",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "checkout.addressDetailsHint"
                                                                )
                                                              )
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-row__wrapper"
                                                        },
                                                        [
                                                          _c(
                                                            "FormInputSelect",
                                                            {
                                                              attrs: {
                                                                options:
                                                                  _vm.countryOptions,
                                                                label: _vm.$t(
                                                                  "forms.labels.country"
                                                                ),
                                                                name: "country",
                                                                disabled:
                                                                  _vm.formLocked ||
                                                                  _vm.shippingAddressLocked
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.form
                                                                    .shippingAddress
                                                                    .countryCode,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm.form
                                                                      .shippingAddress,
                                                                    "countryCode",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "form.shippingAddress.countryCode"
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "input-row" },
                                                [
                                                  _c("ValidationProvider", {
                                                    staticClass:
                                                      "input-row__wrapper",
                                                    attrs: {
                                                      name: "shippingPhone",
                                                      rules: _vm.shippingAddressLocked
                                                        ? ""
                                                        : "required|phone",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        ),
                                                        phone: _vm.$t(
                                                          "forms.errors.phone"
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            var validated =
                                                              ref.validated
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "tel",
                                                                  placeholder: _vm.$t(
                                                                    "forms.labels.phone"
                                                                  ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.phone"
                                                                  ),
                                                                  name: "phone",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  disabled:
                                                                    _vm.formLocked ||
                                                                    _vm.shippingAddressLocked,
                                                                  required: !_vm.shippingAddressLocked
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.form
                                                                      .shippingAddress
                                                                      .phoneNumber,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.form
                                                                        .shippingAddress,
                                                                      "phoneNumber",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "form.shippingAddress.phoneNumber"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              invalid &&
                                                              validated
                                                                ? _c("span", {
                                                                    staticClass:
                                                                      "input-error",
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    }
                                                                  })
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c("span", {
                                                                staticClass:
                                                                  "additional-info",
                                                                domProps: {
                                                                  innerHTML: _vm._s(
                                                                    _vm.$t(
                                                                      "checkout.phoneHint"
                                                                    )
                                                                  )
                                                                }
                                                              })
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                : _vm._e()
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showReusableDishes
                        ? _c(
                            "div",
                            { staticClass: "checkout-form__block" },
                            [
                              _c("h2", {
                                staticClass: "checkout-form__block-title",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("checkout.reusableDishes.title")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "FormInputCheckbox",
                                {
                                  attrs: {
                                    name: "reusableDishes",
                                    value: "reusableDishes",
                                    immediate: "",
                                    disabled:
                                      _vm.formLocked || _vm.reusableDishLocked
                                  },
                                  model: {
                                    value: _vm.form.useDishes,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "useDishes", $$v)
                                    },
                                    expression: "form.useDishes"
                                  }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("checkout.reusableDishes.label")
                                      )
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.timeDisabled
                        ? _c(
                            "div",
                            { staticClass: "checkout-form__block" },
                            [
                              _c("h2", {
                                staticClass: "checkout-form__block-title",
                                domProps: { innerHTML: _vm._s(_vm.timeTitle) }
                              }),
                              _vm._v(" "),
                              _vm.cartBigOrderText
                                ? _c("GeneralMessage", {
                                    ref: "notificationMessages",
                                    attrs: {
                                      message: _vm.cartBigOrderText,
                                      type: "warning",
                                      stick: ""
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "checkout-form__time" },
                                [
                                  _c("SVGClock", {
                                    staticClass: "checkout-form__time-icon"
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "checkout-form__time-text",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.deliveryTimeEnhanced
                                      )
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.isIndining && !_vm.timeLocked
                                ? _c("Button", {
                                    staticClass: "checkout-form__time-edit",
                                    attrs: {
                                      type: "button",
                                      level: "tertiary",
                                      arrow: "",
                                      text: _vm.timeEditLabel,
                                      disabled: _vm.formLocked
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.onTimeEdit.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isDelivery && !_vm.dropoffDisabled
                        ? _c("div", { staticClass: "checkout-form__block" }, [
                            _c("h2", {
                              staticClass: "checkout-form__block-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("checkout.dropoff.title")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "input-row" },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "input-row__wrapper",
                                  attrs: {
                                    name: "dropoffType",
                                    rules: _vm.dropoffLocked ? "" : "required",
                                    tag: "div",
                                    customMessages: {
                                      required: _vm.$t("checkout.dropoff.error")
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          var invalid = ref.invalid
                                          var validated = ref.validated
                                          return [
                                            _c("FormInputRadio", {
                                              attrs: {
                                                name: "dropoffType",
                                                options: _vm.dropoffOptions,
                                                vertical: "",
                                                required: !_vm.dropoffLocked,
                                                disabled:
                                                  _vm.formLocked ||
                                                  _vm.dropoffLocked
                                              },
                                              model: {
                                                value: _vm.form.dropoffType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "dropoffType",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.dropoffType"
                                              }
                                            }),
                                            _vm._v(" "),
                                            invalid && validated
                                              ? _c("span", {
                                                  staticClass: "input-error",
                                                  domProps: {
                                                    innerHTML: _vm._s(errors[0])
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.notesDisabled
                        ? _c("div", { staticClass: "checkout-form__block" }, [
                            _c("h2", {
                              staticClass: "checkout-form__block-title",
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("checkout.notesTitle"))
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "input-row" },
                              [
                                _c("FormInputTextarea", {
                                  attrs: {
                                    placeholder: _vm.$t("forms.labels.notes"),
                                    label: _vm.$t("forms.labels.notes"),
                                    disabled: _vm.formLocked || _vm.notesLocked
                                  },
                                  model: {
                                    value: _vm.form.notes,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "notes", $$v)
                                    },
                                    expression: "form.notes"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.checkoutPayments.length && !_vm.paymentDisabled
                        ? _c(
                            "div",
                            {
                              ref: "payments",
                              staticClass: "checkout-form__block"
                            },
                            [
                              _c("h2", {
                                staticClass: "checkout-form__block-title",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("checkout.paymentTitle")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.showSavedPayments
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "input-row" },
                                      [
                                        _c("ValidationProvider", {
                                          attrs: {
                                            rules: "",
                                            name: "savedPayment",
                                            tag: "div",
                                            customMessages: {
                                              required: _vm.$t(
                                                "checkout.errorPaymentMethod"
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var invalid = ref.invalid
                                                  var errors = ref.errors
                                                  var validated = ref.validated
                                                  return [
                                                    _c(
                                                      "CheckoutSavedPayments",
                                                      {
                                                        attrs: {
                                                          payments:
                                                            _vm.savedPayments,
                                                          disabled:
                                                            _vm.formLocked ||
                                                            _vm.paymentLocked
                                                        },
                                                        on: {
                                                          delete:
                                                            _vm.onDeletePayment
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.selectedSavedPaymentToken,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.selectedSavedPaymentToken = $$v
                                                          },
                                                          expression:
                                                            "selectedSavedPaymentToken"
                                                        }
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    invalid && validated
                                                      ? _c("span", {
                                                          staticClass:
                                                            "input-error",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              errors[0]
                                                            )
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.showPaymentMethods
                                      ? _c("Button", {
                                          attrs: {
                                            type: "button",
                                            level: "tertiary",
                                            text: _vm.$t(
                                              "checkout.savedPayments.changeMethod"
                                            ),
                                            arrow: "",
                                            disabled: _vm.formLocked
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.onShowPaymentMethods.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.showSavedPayments ||
                              _vm.showPaymentMethods ||
                              !_vm.savedPayments.length
                                ? _c(
                                    "div",
                                    { staticClass: "input-row" },
                                    [
                                      _vm.checkoutPayments.length
                                        ? _c("ValidationProvider", {
                                            attrs: {
                                              rules: _vm.paymentLocked
                                                ? ""
                                                : "required",
                                              name: "paymentCode",
                                              tag: "div",
                                              customMessages: {
                                                required: _vm.$t(
                                                  "checkout.errorPaymentMethod"
                                                )
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var invalid = ref.invalid
                                                    var errors = ref.errors
                                                    var validated =
                                                      ref.validated
                                                    return [
                                                      _c("FormInputPayment", {
                                                        attrs: {
                                                          methods:
                                                            _vm.checkoutPayments,
                                                          disabled:
                                                            _vm.formLocked ||
                                                            _vm.paymentLocked
                                                        },
                                                        on: {
                                                          input:
                                                            _vm.onPaymentChanged
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form
                                                              .paymentCode,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "paymentCode",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.paymentCode"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      invalid && validated
                                                        ? _c("span", {
                                                            staticClass:
                                                              "input-error",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                errors[0]
                                                              )
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showBillingAddress && !_vm.billingAddressDisabled
                        ? _c(
                            "div",
                            { staticClass: "checkout-form__block" },
                            [
                              _c("h2", {
                                staticClass: "checkout-form__block-title",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("checkout.billingAddress")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.isDelivery
                                ? _c(
                                    "FormInputCheckbox",
                                    {
                                      attrs: {
                                        name: "billingAddressIdentical",
                                        value: "billingAddressIdentical",
                                        disabled:
                                          _vm.formLocked ||
                                          _vm.billingAddressLocked,
                                        immediate: ""
                                      },
                                      model: {
                                        value: _vm.form.billingAddressIdentical,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "billingAddressIdentical",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "form.billingAddressIdentical"
                                      }
                                    },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "checkout.billingAddressIdentical"
                                            )
                                          )
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.form.billingAddressIdentical ||
                              !_vm.isDelivery
                                ? _c("ValidationObserver", {
                                    ref: "billingAddress",
                                    attrs: {
                                      tag: "section",
                                      vid: "billingAddress"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "input-row" },
                                                [
                                                  _c("ValidationProvider", {
                                                    staticClass:
                                                      "input-row__wrapper",
                                                    attrs: {
                                                      name: "billingFirstname",
                                                      rules: _vm.billingAddressLocked
                                                        ? ""
                                                        : "required",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            var validated =
                                                              ref.validated
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "text",
                                                                  placeholder: _vm.$t(
                                                                    "forms.labels.firstname"
                                                                  ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.firstname"
                                                                  ),
                                                                  name:
                                                                    "firstname",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  disabled:
                                                                    _vm.formLocked ||
                                                                    _vm.billingAddressLocked,
                                                                  required: !_vm.billingAddressLocked
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.form
                                                                      .billingAddress
                                                                      .firstName,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.form
                                                                        .billingAddress,
                                                                      "firstName",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "form.billingAddress.firstName"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              invalid &&
                                                              validated
                                                                ? _c("span", {
                                                                    staticClass:
                                                                      "input-error",
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    }
                                                                  })
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    staticClass:
                                                      "input-row__wrapper",
                                                    attrs: {
                                                      name: "billingLastname",
                                                      rules: _vm.billingAddressLocked
                                                        ? ""
                                                        : "required",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            var validated =
                                                              ref.validated
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "text",
                                                                  placeholder: _vm.$t(
                                                                    "forms.labels.lastname"
                                                                  ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.lastname"
                                                                  ),
                                                                  name:
                                                                    "lastname",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  disabled:
                                                                    _vm.formLocked ||
                                                                    _vm.billingAddressLocked,
                                                                  required: !_vm.billingAddressLocked
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.form
                                                                      .billingAddress
                                                                      .lastName,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.form
                                                                        .billingAddress,
                                                                      "lastName",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "form.billingAddress.lastName"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              invalid &&
                                                              validated
                                                                ? _c("span", {
                                                                    staticClass:
                                                                      "input-error",
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    }
                                                                  })
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "input-row" },
                                                [
                                                  _c("FormInput", {
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: _vm.$t(
                                                        "forms.labels.company"
                                                      ),
                                                      label: _vm.$t(
                                                        "forms.labels.company"
                                                      ),
                                                      labelOption: _vm.$t(
                                                        "forms.labels.optional"
                                                      ),
                                                      name: "company",
                                                      disabled:
                                                        _vm.formLocked ||
                                                        _vm.billingAddressLocked
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.billingAddress
                                                          .company,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form
                                                            .billingAddress,
                                                          "company",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.billingAddress.company"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "input-row" },
                                                [
                                                  _c("ValidationObserver", {
                                                    ref: "billingStreetNr",
                                                    staticClass:
                                                      "input-row__wrapper",
                                                    attrs: { tag: "div" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var validated =
                                                              ref.validated
                                                            var invalid =
                                                              ref.invalid
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group"
                                                                },
                                                                [
                                                                  _c(
                                                                    "ValidationProvider",
                                                                    {
                                                                      staticClass:
                                                                        "input-group__span-9",
                                                                      attrs: {
                                                                        name:
                                                                          "billingStreet",
                                                                        rules: _vm.billingAddressLocked
                                                                          ? ""
                                                                          : "required",
                                                                        tag:
                                                                          "div",
                                                                        customMessages: {
                                                                          required: _vm.$t(
                                                                            "forms.errors.fieldEmpty"
                                                                          )
                                                                        }
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "default",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var errors =
                                                                                ref.errors
                                                                              var invalid =
                                                                                ref.invalid
                                                                              return [
                                                                                _c(
                                                                                  "FormInput",
                                                                                  {
                                                                                    attrs: {
                                                                                      type:
                                                                                        "text",
                                                                                      placeholder: _vm.$t(
                                                                                        "forms.labels.street"
                                                                                      ),
                                                                                      label: _vm.$t(
                                                                                        "forms.labels.street"
                                                                                      ),
                                                                                      name:
                                                                                        "street",
                                                                                      error:
                                                                                        errors.length >
                                                                                        0,
                                                                                      disabled:
                                                                                        _vm.formLocked ||
                                                                                        _vm.billingAddressLocked,
                                                                                      required: !_vm.billingAddressLocked
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm
                                                                                          .form
                                                                                          .billingAddress
                                                                                          .street,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .form
                                                                                            .billingAddress,
                                                                                          "street",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "form.billingAddress.street"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "ValidationProvider",
                                                                    {
                                                                      staticClass:
                                                                        "input-group__span-3",
                                                                      attrs: {
                                                                        name:
                                                                          "billingStreetNumber",
                                                                        rules: _vm.billingAddressLocked
                                                                          ? ""
                                                                          : "required",
                                                                        tag:
                                                                          "div",
                                                                        customMessages: {
                                                                          required: _vm.$t(
                                                                            "forms.errors.fieldEmpty"
                                                                          )
                                                                        }
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "default",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var errors =
                                                                                ref.errors
                                                                              var invalid =
                                                                                ref.invalid
                                                                              return [
                                                                                _c(
                                                                                  "FormInput",
                                                                                  {
                                                                                    attrs: {
                                                                                      type:
                                                                                        "text",
                                                                                      placeholder: _vm.$t(
                                                                                        "forms.labels.number"
                                                                                      ),
                                                                                      label: _vm.$t(
                                                                                        "forms.labels.number"
                                                                                      ),
                                                                                      name:
                                                                                        "number",
                                                                                      error:
                                                                                        errors.length >
                                                                                        0,
                                                                                      disabled:
                                                                                        _vm.formLocked ||
                                                                                        _vm.billingAddressLocked,
                                                                                      required: !_vm.billingAddressLocked
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm
                                                                                          .form
                                                                                          .billingAddress
                                                                                          .streetNumber,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .form
                                                                                            .billingAddress,
                                                                                          "streetNumber",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "form.billingAddress.streetNumber"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              invalid &&
                                                              validated
                                                                ? _c("div", {
                                                                    staticClass:
                                                                      "input-error input-group__span-12",
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        Object.values(
                                                                          errors
                                                                        )
                                                                          .filter(
                                                                            function(
                                                                              value
                                                                            ) {
                                                                              return !!value
                                                                                .join(
                                                                                  ""
                                                                                )
                                                                                .trim()
                                                                            }
                                                                          )
                                                                          .join(
                                                                            " "
                                                                          )
                                                                      )
                                                                    }
                                                                  })
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ValidationObserver", {
                                                    ref: "billingZipCity",
                                                    staticClass:
                                                      "input-row__wrapper",
                                                    attrs: { tag: "div" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var dirty =
                                                              ref.dirty
                                                            var validated =
                                                              ref.validated
                                                            var invalid =
                                                              ref.invalid
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group"
                                                                },
                                                                [
                                                                  _c(
                                                                    "ValidationProvider",
                                                                    {
                                                                      staticClass:
                                                                        "input-group__span-4 input-group__span-xxl-3",
                                                                      attrs: {
                                                                        name:
                                                                          "billingZip",
                                                                        rules: _vm.billingAddressLocked
                                                                          ? ""
                                                                          : "required|digits:4",
                                                                        tag:
                                                                          "div",
                                                                        customMessages: {
                                                                          required: _vm.$t(
                                                                            "forms.errors.fieldEmpty"
                                                                          ),
                                                                          digits: _vm.$t(
                                                                            "forms.errors.zip"
                                                                          )
                                                                        }
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "default",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var errors =
                                                                                ref.errors
                                                                              var invalid =
                                                                                ref.invalid
                                                                              return [
                                                                                _c(
                                                                                  "FormInput",
                                                                                  {
                                                                                    ref:
                                                                                      "billingZipInput",
                                                                                    attrs: {
                                                                                      type:
                                                                                        "text",
                                                                                      name:
                                                                                        "zip",
                                                                                      placeholder: _vm.$t(
                                                                                        "forms.labels.zip"
                                                                                      ),
                                                                                      label: _vm.$t(
                                                                                        "forms.labels.zip"
                                                                                      ),
                                                                                      minlength: 4,
                                                                                      maxlength: 4,
                                                                                      inputmode:
                                                                                        "decimal",
                                                                                      pattern:
                                                                                        "[0-9]{4}",
                                                                                      error:
                                                                                        errors.length >
                                                                                        0,
                                                                                      disabled:
                                                                                        _vm.formLocked ||
                                                                                        _vm.billingAddressLocked,
                                                                                      required: !_vm.billingAddressLocked
                                                                                    },
                                                                                    on: {
                                                                                      keydown:
                                                                                        _vm.onZipKeydown,
                                                                                      input:
                                                                                        _vm.onZipInputBilling
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm
                                                                                          .form
                                                                                          .billingAddress
                                                                                          .postcode,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .form
                                                                                            .billingAddress,
                                                                                          "postcode",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "form.billingAddress.postcode"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "ValidationProvider",
                                                                    {
                                                                      staticClass:
                                                                        "input-group__span-8 input-group__span-xxl-9",
                                                                      attrs: {
                                                                        name:
                                                                          "billingCity",
                                                                        rules: _vm.billingAddressLocked
                                                                          ? ""
                                                                          : "required",
                                                                        tag:
                                                                          "div",
                                                                        customMessages: {
                                                                          required: _vm.$t(
                                                                            "forms.errors.fieldEmpty"
                                                                          )
                                                                        }
                                                                      },
                                                                      scopedSlots: _vm._u(
                                                                        [
                                                                          {
                                                                            key:
                                                                              "default",
                                                                            fn: function(
                                                                              ref
                                                                            ) {
                                                                              var errors =
                                                                                ref.errors
                                                                              var invalid =
                                                                                ref.invalid
                                                                              return [
                                                                                _c(
                                                                                  "FormInput",
                                                                                  {
                                                                                    attrs: {
                                                                                      type:
                                                                                        "text",
                                                                                      placeholder: _vm.$t(
                                                                                        "forms.labels.city"
                                                                                      ),
                                                                                      label: _vm.$t(
                                                                                        "forms.labels.city"
                                                                                      ),
                                                                                      name:
                                                                                        "city",
                                                                                      error:
                                                                                        errors.length >
                                                                                        0,
                                                                                      disabled:
                                                                                        _vm.formLocked ||
                                                                                        _vm.billingAddressLocked,
                                                                                      required: !_vm.billingAddressLocked
                                                                                    },
                                                                                    model: {
                                                                                      value:
                                                                                        _vm
                                                                                          .form
                                                                                          .billingAddress
                                                                                          .city,
                                                                                      callback: function(
                                                                                        $$v
                                                                                      ) {
                                                                                        _vm.$set(
                                                                                          _vm
                                                                                            .form
                                                                                            .billingAddress,
                                                                                          "city",
                                                                                          $$v
                                                                                        )
                                                                                      },
                                                                                      expression:
                                                                                        "form.billingAddress.city"
                                                                                    }
                                                                                  }
                                                                                )
                                                                              ]
                                                                            }
                                                                          }
                                                                        ],
                                                                        null,
                                                                        true
                                                                      )
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              invalid &&
                                                              (validated ||
                                                                dirty)
                                                                ? _c("div", {
                                                                    staticClass:
                                                                      "input-error input-group__span-12",
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        Object.values(
                                                                          errors
                                                                        )
                                                                          .filter(
                                                                            function(
                                                                              value
                                                                            ) {
                                                                              return !!value
                                                                                .join(
                                                                                  ""
                                                                                )
                                                                                .trim()
                                                                            }
                                                                          )
                                                                          .join(
                                                                            " "
                                                                          )
                                                                      )
                                                                    }
                                                                  })
                                                                : _vm._e()
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "input-row" },
                                                [
                                                  _c("FormInputSelect", {
                                                    attrs: {
                                                      options:
                                                        _vm.countryOptions,
                                                      label: _vm.$t(
                                                        "forms.labels.country"
                                                      ),
                                                      name: "country",
                                                      disabled:
                                                        _vm.formLocked ||
                                                        _vm.billingAddressLocked
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.billingAddress
                                                          .countryCode,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.form
                                                            .billingAddress,
                                                          "countryCode",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.billingAddress.countryCode"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "input-row" },
                                                [
                                                  _c("ValidationProvider", {
                                                    staticClass:
                                                      "input-row__wrapper",
                                                    attrs: {
                                                      name: "billingPhone",
                                                      rules: _vm.billingAddressLocked
                                                        ? ""
                                                        : "required|phone",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        ),
                                                        phone: _vm.$t(
                                                          "forms.errors.phone"
                                                        )
                                                      }
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function(ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            var validated =
                                                              ref.validated
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "tel",
                                                                  placeholder: _vm.$t(
                                                                    "forms.labels.phone"
                                                                  ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.phone"
                                                                  ),
                                                                  name: "phone",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  disabled:
                                                                    _vm.formLocked ||
                                                                    _vm.billingAddressLocked,
                                                                  required: !_vm.billingAddressLocked
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.form
                                                                      .billingAddress
                                                                      .phoneNumber,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.form
                                                                        .billingAddress,
                                                                      "phoneNumber",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "form.billingAddress.phoneNumber"
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              invalid &&
                                                              validated
                                                                ? _c("span", {
                                                                    staticClass:
                                                                      "input-error",
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    }
                                                                  })
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c("span", {
                                                                staticClass:
                                                                  "additional-info",
                                                                domProps: {
                                                                  innerHTML: _vm._s(
                                                                    _vm.$t(
                                                                      "checkout.phoneHint"
                                                                    )
                                                                  )
                                                                }
                                                              })
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showTipInput
                        ? _c("div", [
                            _c("h2", {
                              staticClass: "checkout-form__block-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.cartTipVariant.title ||
                                    _vm.$t("checkout.tipTitle")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _vm.cartTipVariant.hint
                              ? _c("div", {
                                  staticClass: "checkout-form__block-text",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.cartTipVariant.hint)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "input-row" },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "input-row__wrapper",
                                  attrs: {
                                    name: "tip",
                                    rules: _vm.tipLocked ? "" : "required",
                                    tag: "div",
                                    customMessages: {
                                      required: _vm.$t("checkout.errorTip")
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var errors = ref.errors
                                          var invalid = ref.invalid
                                          var validated = ref.validated
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.cartTipOption,
                                                  expression: "cartTipOption"
                                                }
                                              ],
                                              attrs: { type: "hidden" },
                                              domProps: {
                                                value: _vm.cartTipOption
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.cartTipOption =
                                                    $event.target.value
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("TipInput", {
                                              attrs: {
                                                options:
                                                  _vm.cartTipVariant.options,
                                                selected: _vm.cartTipOption,
                                                tip: _vm.cartTip,
                                                "tip-percent":
                                                  _vm.cartTipPercent,
                                                locked:
                                                  _vm.formLocked ||
                                                  _vm.tipLocked
                                              },
                                              on: {
                                                "tip:option": _vm.onTipOption,
                                                "tip:percent": _vm.onTipPercent,
                                                "tip:value": _vm.onTipValue
                                              }
                                            }),
                                            _vm._v(" "),
                                            invalid && validated
                                              ? _c("span", {
                                                  staticClass: "input-error",
                                                  domProps: {
                                                    innerHTML: _vm._s(errors[0])
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.promotionCouponLocked && !_vm.promotionCouponDisabled
                        ? _c("div", { staticClass: "checkout-form__block" }, [
                            _c("h2", {
                              staticClass: "checkout-form__block-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("checkout.couponTitle")
                                )
                              }
                            }),
                            _vm._v(" "),
                            !_vm.isLoggedIn
                              ? _c(
                                  "div",
                                  { staticClass: "checkout-form__block-text" },
                                  [
                                    _c("Button", {
                                      attrs: {
                                        level: "tertiary",
                                        type: "button",
                                        text: _vm.$t("checkout.couponLogin"),
                                        arrow: "",
                                        disabled: _vm.formLocked
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.onLoginClick.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm.isLoggedIn && _vm.accountCoupons.length
                              ? _c(
                                  "div",
                                  { staticClass: "input-row" },
                                  [
                                    _c("CheckoutUserCoupons", {
                                      attrs: {
                                        coupons: _vm.accountCouponsEnhanced,
                                        disabled: _vm.formLocked
                                      },
                                      on: { input: _vm.onCouponCodeSelect }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-row" }, [
                              _c(
                                "div",
                                { staticClass: "input-row__wrapper" },
                                [
                                  _c("ValidationProvider", {
                                    ref: "couponCode",
                                    attrs: {
                                      rules: { regex: /.{3,40}/ },
                                      name: "couponCode",
                                      tag: "div",
                                      customMessages: {
                                        regex: _vm.$t("forms.errors.format")
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var invalid = ref.invalid
                                            var errors = ref.errors
                                            var validated = ref.validated
                                            return [
                                              _c("FormInput", {
                                                attrs: {
                                                  label: _vm.$t(
                                                    "checkout.couponLabel"
                                                  ),
                                                  placeholder: _vm.$t(
                                                    "checkout.couponLabel"
                                                  ),
                                                  error: errors.length > 0,
                                                  disabled: _vm.formLocked
                                                },
                                                on: {
                                                  keydown: function($event) {
                                                    if (
                                                      !$event.type.indexOf(
                                                        "key"
                                                      ) &&
                                                      _vm._k(
                                                        $event.keyCode,
                                                        "enter",
                                                        13,
                                                        $event.key,
                                                        "Enter"
                                                      )
                                                    ) {
                                                      return null
                                                    }
                                                    $event.preventDefault()
                                                    return _vm.addCoupon.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: _vm.couponCode,
                                                  callback: function($$v) {
                                                    _vm.couponCode = $$v
                                                  },
                                                  expression: "couponCode"
                                                }
                                              }),
                                              _vm._v(" "),
                                              invalid && validated
                                                ? _c("span", {
                                                    staticClass: "input-error",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        errors[0]
                                                      )
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.couponSuccess
                                                ? _c("span", {
                                                    staticClass:
                                                      "input-success",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.couponSuccess
                                                      )
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("Button", {
                                    attrs: {
                                      type: "button",
                                      level: "primary",
                                      text: _vm.$t("checkout.couponButton"),
                                      disabled: _vm.formLocked,
                                      small: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.addCoupon.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "checkout-form__info-link",
                                attrs: {
                                  href: _vm.$t("checkout.couponInfoUrl"),
                                  target: "_blank"
                                }
                              },
                              [
                                _c("SVGInfo"),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "checkout-form__info-link-text",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("checkout.couponInfoText")
                                    )
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("CheckoutCartButton", {
                        attrs: { "show-tip": "", "show-co2": "" }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkout-form__block" }, [
                        _c(
                          "div",
                          { staticClass: "accept" },
                          [
                            _vm.cartChannelHasCo2Compensation &&
                            !_vm.co2Disabled
                              ? _c(
                                  "FormInputCheckbox",
                                  {
                                    attrs: {
                                      name: "co2",
                                      value: "co2Compensation",
                                      immediate: "",
                                      disabled: _vm.formLocked || _vm.co2Locked
                                    },
                                    model: {
                                      value: _vm.compensateCo2,
                                      callback: function($$v) {
                                        _vm.compensateCo2 = $$v
                                      },
                                      expression: "compensateCo2"
                                    }
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(_vm.co2CheckboxLabel)
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasFeature("FEATURE_NEWSLETTER_CHECKOUT") &&
                            _vm.showEmail
                              ? _c(
                                  "FormInputCheckbox",
                                  {
                                    attrs: {
                                      name: "newsletter",
                                      value: "newsletter",
                                      disabled: _vm.formLocked,
                                      immediate: ""
                                    },
                                    model: {
                                      value: _vm.form.subscribedToNewsletter,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "subscribedToNewsletter",
                                          $$v
                                        )
                                      },
                                      expression: "form.subscribedToNewsletter"
                                    }
                                  },
                                  [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("checkout.newsletterLabel")
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.cartIncludesAlcohol
                              ? _c("ValidationProvider", {
                                  attrs: {
                                    rules: { required: { allowFalse: false } },
                                    name: "checkAlcohol",
                                    tag: "div",
                                    customMessages: {
                                      required: _vm.$t("checkout.errorAlcohol")
                                    }
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(ref) {
                                          var invalid = ref.invalid
                                          var errors = ref.errors
                                          var validated = ref.validated
                                          return [
                                            _c(
                                              "FormInputCheckbox",
                                              {
                                                attrs: {
                                                  name: "alcohol",
                                                  value: "checkAlcohol",
                                                  disabled: _vm.formLocked,
                                                  required: "",
                                                  immediate: ""
                                                },
                                                model: {
                                                  value: _vm.form.checkAlcohol,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.form,
                                                      "checkAlcohol",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "form.checkAlcohol"
                                                }
                                              },
                                              [
                                                _c("span", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "checkout.alcoholLabel"
                                                      )
                                                    )
                                                  }
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            invalid && validated
                                              ? _c("span", {
                                                  staticClass: "input-error",
                                                  domProps: {
                                                    innerHTML: _vm._s(errors[0])
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("ValidationProvider", {
                              attrs: {
                                rules: { required: { allowFalse: false } },
                                name: "acceptTerms",
                                tag: "div",
                                customMessages: {
                                  required: _vm.$t("checkout.errorTerms")
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      var errors = ref.errors
                                      var validated = ref.validated
                                      return [
                                        _c(
                                          "FormInputCheckbox",
                                          {
                                            attrs: {
                                              name: "terms",
                                              value: "acceptTerms",
                                              disabled: _vm.formLocked,
                                              required: "",
                                              immediate: ""
                                            },
                                            model: {
                                              value: _vm.form.acceptTerms,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "acceptTerms",
                                                  $$v
                                                )
                                              },
                                              expression: "form.acceptTerms"
                                            }
                                          },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t("checkout.termsLabel")
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        invalid && validated
                                          ? _c("span", {
                                              staticClass: "input-error",
                                              domProps: {
                                                innerHTML: _vm._s(errors[0])
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _vm._v(" "),
                            _c("ValidationProvider", {
                              attrs: {
                                rules: { required: { allowFalse: false } },
                                name: "acceptPrivacy",
                                tag: "div",
                                customMessages: {
                                  required: _vm.$t("checkout.errorPrivacy")
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var invalid = ref.invalid
                                      var errors = ref.errors
                                      var validated = ref.validated
                                      return [
                                        _c(
                                          "FormInputCheckbox",
                                          {
                                            attrs: {
                                              name: "terms",
                                              value: "acceptPrivacy",
                                              disabled: _vm.formLocked,
                                              required: "",
                                              immediate: ""
                                            },
                                            model: {
                                              value: _vm.form.acceptPrivacy,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "acceptPrivacy",
                                                  $$v
                                                )
                                              },
                                              expression: "form.acceptPrivacy"
                                            }
                                          },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t(
                                                    "checkout.privacyLabel"
                                                  )
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        invalid && validated
                                          ? _c("span", {
                                              staticClass: "input-error",
                                              domProps: {
                                                innerHTML: _vm._s(errors[0])
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            }),
                            _vm._v(" "),
                            _c("Button", {
                              attrs: {
                                type: "submit",
                                level: "primary",
                                text: _vm.$t("checkout.orderButton"),
                                disabled: _vm.formLocked
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                !_vm.cartIsDetached
                                  ? _c("Button", {
                                      staticClass:
                                        "checkout-form__back-to-shop checkout-form__back-to-shop--bottom",
                                      attrs: {
                                        level: "tertiary",
                                        type: "button",
                                        text: _vm.$t(
                                          "checkout.continueShopping"
                                        ),
                                        arrow: "",
                                        reverse: "",
                                        disabled: _vm.formLocked
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.backToShop.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  }
                }
              ])
            })
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "checkout-form__cart-placeholder" },
      [
        _c("OverlaySidebarCart", {
          ref: "sidebarCart",
          staticClass: "insicht insicht--fade-up insicht--fast",
          attrs: {
            "is-editable": false,
            "is-inline": "",
            "show-co2": "",
            "show-tip": ""
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }